import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Plus from 'UI/IconsSrc/plus';
import Minus from 'UI/IconsSrc/minus';

var Expandable = /*#__PURE__*/function (_Component) {
  _inherits(Expandable, _Component);

  var _super = _createSuper(Expandable);

  function Expandable(props) {
    var _this;

    _classCallCheck(this, Expandable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onPress", function (event) {
      event.preventDefault();

      if (_this.props.onClick && typeof _this.props.onClick == 'function') {
        _this.props.onClick(_this.toggleOpen);

        return true;
      }

      _this.toggleOpen();
    });

    _defineProperty(_assertThisInitialized(_this), "onPlusPress", function (event) {
      event.preventDefault();

      if (_this.props.onPlus && typeof _this.props.onPlus == 'function') {
        _this.props.onPlus(_this.toggleOpen);

        return true;
      } else {
        if (_this.props.onClick && typeof _this.props.onClick == 'function') {
          _this.onPress(event);

          return true;
        }
      }

      _this.toggleOpen();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function (isOpen) {
      if (typeof isOpen != 'undefined' && isOpen != null) {
        _this.setState({
          open: isOpen
        });
      } else {
        _this.setState({
          open: !_this.state.open
        });
      }

      if (_this.props.onChange && typeof _this.props.onChange == 'function') {
        _this.props.onChange(isOpen ? isOpen : !_this.state.open);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getContentClassNames", function () {
      var className = 'expandable-content';
      var open = _this.state.open;
      var centerContent = _this.props.centerContent;
      var whiteBackground = _this.props.whiteBackground;

      if (open) {
        className += ' open';
      }

      if (centerContent) {
        className += ' centerContent';
      }

      if (whiteBackground) {
        className += ' expandable-white-bg';
      }

      return className;
    });

    _defineProperty(_assertThisInitialized(_this), "getHeaderClassNames", function () {
      var className = 'expandable-header';
      var open = _this.state.open;
      var color = _this.props.color;

      if (open) {
        className += ' open';
      }

      if (color) {
        className += ' has-color';
      }

      return className;
    });

    _this.state = {
      open: props.open || false
    };
    return _this;
  }

  _createClass(Expandable, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps && nextProps.open != null) {
        if (this.props.ignorePropsUpdate) {
          return true;
        }

        if (nextProps.open != this.state.open) {
          this.toggleOpen(nextProps.open);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          title = _this$props.title,
          color = _this$props.color,
          html = _this$props.html,
          headerStyles = _this$props.headerStyles,
          contentStyles = _this$props.contentStyles,
          contentStylesClosed = _this$props.contentStylesClosed;
      var open = this.state.open;
      var style = typeof color !== 'undefined' ? {
        borderLeftColor: color
      } : {};
      return /*#__PURE__*/React.createElement("div", {
        className: "expandable-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getHeaderClassNames(),
        style: _objectSpread(_objectSpread({}, headerStyles), style)
      }, this.props.index ? /*#__PURE__*/React.createElement("span", null, this.props.index, "\xA0") : null, /*#__PURE__*/React.createElement("span", {
        onClick: this.onPress,
        className: "title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "trigger-container",
        onClick: this.onPlusPress
      }, /*#__PURE__*/React.createElement("span", {
        className: "trigger"
      }, open ? /*#__PURE__*/React.createElement(Minus, null) : /*#__PURE__*/React.createElement(Plus, null)))), html != null ? /*#__PURE__*/React.createElement("div", {
        className: this.getContentClassNames(),
        style: open ? contentStyles : contentStylesClosed,
        dangerouslySetInnerHTML: {
          __html: children
        }
      }) : /*#__PURE__*/React.createElement("div", {
        className: this.getContentClassNames(),
        style: open ? contentStyles : contentStylesClosed
      }, this.props.overrideOpen != null && this.props.overrideOpen && open ? children : null, this.props.overrideOpen == null ? children : null));
    }
  }]);

  return Expandable;
}(Component);

_defineProperty(Expandable, "defaultProps", {
  title: 'Visa mer',
  children: '',
  centerContent: false,
  ignorePropsUpdate: false
});

export default Expandable;